import * as React from 'react';
import { Grid, StyledComponentProps, withStyles, FormControlLabel, Checkbox } from '@material-ui/core';
import TextField from '../../../../ui-components/TextField/TextField';
import Button from '../../../../ui-components/Button/Button';
import { styles } from './styles';

interface IProps extends StyledComponentProps {
    loadDelivered: (title: string, description: string, yesNoQuestion: boolean) => void;
}

interface IInternalState {
    title: string;
    description: string;
    yesNoQuestion: boolean;
}


class Filter extends React.Component<Partial<IProps>, IInternalState>
{
    state = {
        title: undefined,
        description: undefined,
        yesNoQuestion: false
    }

    private handleChangeTitle = (val: string) => {
        this.setState({ title: val })
    }
    private handleChangeDescription = (val: string) => {
        this.setState({ description: val })
    }
    private handleChangeYesNo = () => {
        this.setState({ yesNoQuestion: !this.state.yesNoQuestion })
    }
    private search = () => {
        this.props.loadDelivered(this.state.title, this.state.description, this.state.yesNoQuestion);
    }

    render() {
        const classes = this.props.classes;
        return (<>
            <Grid container className={classes.root}>
                <Grid item sm={4} xs={12} className={this.props.classes.searchField}>
                    <TextField label='Titolo' onChange={this.handleChangeTitle} value={this.state.title} />
                </Grid>

                <Grid item sm={4} xs={12} className={this.props.classes.searchField}>
                    <TextField label='Descrizione' onChange={this.handleChangeDescription} value={this.state.description} />
                </Grid>

                <Grid item sm={2} xs={12}>
                    <FormControlLabel className={this.props.classes.voteLabel}
                        control={<Checkbox checked={this.state.yesNoQuestion} onChange={this.handleChangeYesNo} />}
                        label="Con votazione"
                    />
                    <Button onClick={this.search}> Cerca
                    </Button>
                </Grid>
                {/* <Grid item sm={1} xs={9} className={classes.voteButton}>
                    <FormControlLabel
                        control={<Checkbox checked={this.state.yesNoQuestion} onChange={this.handleChangeYesNo} />}
                        label="Con votazione"
                    />
                </Grid>
                <Grid item xs={3} sm={1} alignItems="center" >
                    <Button onClick={this.search}> Cerca
                    </Button>
                </Grid> */}
            </Grid>
        </>
        );
    }
}

export default withStyles(styles)(Filter)